import PropTypes from "prop-types";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import CountUp from "react-countup";
import classes from "./styles.module.scss";
import VisibilitySensor from "react-visibility-sensor";
import { Title, Description } from "@/ui";

export default function StatCounterWidget({ className, title, description, items }) {
  return (
    <div className={clsx(className, classes.StatCounterWidget)}>
      <VisibilitySensor>
        {() => (
          <Container>
            <Title title={title} tag="h5" className="mb-5" />
            <Row>
              {items.map((i, k) => (
                <Col key={k} xs={12} md={4} className="mb-4 mb-md-0">
                  <dl>
                    <dd>
                      {i.prefix}
                      <CountUp end={i.value} redraw={true} />
                      {i.suffix}
                    </dd>
                    <dt>{i.label}</dt>
                  </dl>
                </Col>
              ))}
            </Row>
            <Description description={description} className="mt-5 small" />
          </Container>
        )}
      </VisibilitySensor>
    </div>
  );
}

StatCounterWidget.defaultProps = {
  className: "py-5",
};

StatCounterWidget.propTypes = {
  className: PropTypes.string,
};
